import { Directive, ElementRef, inject, NgZone, OnDestroy, OnInit, output, Renderer2 } from '@angular/core';

@Directive({
  // eslint-disable-next-line @angular-eslint/directive-selector
  selector: '[clickOrDrag]'
})
export class ClickOrDragDirective implements OnInit, OnDestroy {
  actualClick = output<HTMLElement>();

  private isDragging = false;
  private mouseDownPos = { x: 0, y: 0 };
  private readonly dragThreshold = 5; // pixels to move before considering it a drag
  private unlisteners: (() => void)[] = [];

  private ngZone: NgZone = inject(NgZone);
  private elementRef: ElementRef = inject(ElementRef);
  private renderer: Renderer2 = inject(Renderer2);

  ngOnInit(): void {
    this.ngZone.runOutsideAngular(() => {
      this.unlisteners.push(
        this.renderer.listen(this.elementRef.nativeElement, 'mousedown', (event: MouseEvent) => {
          this.isDragging = false;
          this.mouseDownPos = { x: event.clientX, y: event.clientY };
        })
      );

      this.unlisteners.push(
        this.renderer.listen(this.elementRef.nativeElement, 'mousemove', (event: MouseEvent) => {
          if (!this.mouseDownPos) return;

          const deltaX = Math.abs(event.clientX - this.mouseDownPos.x);
          const deltaY = Math.abs(event.clientY - this.mouseDownPos.y);

          if (deltaX > this.dragThreshold || deltaY > this.dragThreshold) {
            this.isDragging = true;
          }
        })
      );

      this.unlisteners.push(
        this.renderer.listen(this.elementRef.nativeElement, 'mouseup', (event: MouseEvent) => {
          if (!this.isDragging && !event.ctrlKey && !event.shiftKey && !event.altKey && !event.metaKey) {
            this.ngZone.run(() => {
              this.actualClick.emit(this.elementRef.nativeElement);
            });
          }
          this.resetState();
        })
      );

      this.unlisteners.push(
        this.renderer.listen(this.elementRef.nativeElement, 'mouseleave', () => {
          this.resetState();
        })
      );
    });
  }

  ngOnDestroy(): void {
    this.unlisteners.forEach((unlisten) => unlisten());
    this.unlisteners = [];
  }

  private resetState(): void {
    this.mouseDownPos = { x: 0, y: 0 };
    this.isDragging = false;
  }
}
